<div class="input-group">
    <input [type]="showPassword ? 'text' : 'password'" class="form-control" [placeholder]="placeholder"
        [autocomplete]="autocomplete ? autocomplete : 'off'" [ngClass]="ngClass" [disabled]="disabled"
        [required]="required" (input)="onInput($event)" (blur)="onTouched()">
    <div class="input-group-append">
        <button type="button" class="btn btn-outline-secondary  eye-icon-container"
            (click)="togglePasswordVisibility()">
            <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </button>
    </div>
</div>